"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDto = void 0;
const LocationDto_1 = require("../locations/LocationDto");
class UserDto {
    constructor(params) {
        this.userName = "";
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.phone = "";
        this.role = "";
        this.status = "";
        this.password = "";
        this.createdAt = "";
        this.updatedAt = "";
        this.alertNotificationSettings = {};
        if (!params) {
            return;
        }
        this.id = params.id;
        this.userName = params.userName;
        this.firstName = params.firstName;
        this.lastName = params.lastName;
        this.email = params.email;
        this.phone = params.phone;
        this.role = params.role;
        this.status = params.status;
        this.password = params.password;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.alertNotificationSettings = params.alertNotificationSettings;
        if (params.locations !== undefined) {
            this.locations = !params.locations ?
                [] :
                params.locations.map((locationDto) => new LocationDto_1.LocationDto(locationDto));
        }
    }
}
exports.UserDto = UserDto;
//# sourceMappingURL=UserDto.js.map